import { render } from "./footerfile.vue?vue&type=template&id=3337f441"
import script from "./footerfile.vue?vue&type=script&lang=js"
export * from "./footerfile.vue?vue&type=script&lang=js"

import "./footerfile.vue?vue&type=style&index=0&id=3337f441&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__